import {
  fetchResource,
  postResource,
  putResource,
  deleteResource
} from '@/services/fetchService.js'

class CommentService {
  constructor() {
    this.type = ''
  }

  fetchComments = async (targetId) => {
    const params = { target: targetId }
    const comments = await fetchResource('comments', params)
    return comments
  }

  fetchReplies = async (parentId) => {
    const params = { parent: parentId }
    const comments = await fetchResource('comments', params)
    return comments
  }

  addComment = async (comment) => {
    const addedComment = await postResource('comment', comment)
    return addedComment
  }

  modifyComment = async (comment) => {
    const commentId = comment.id
    const modifiedComment = await putResource(`comment/${commentId}`, comment)
    return modifiedComment
  }

  removeComment = async (comment) => {
    const commentId = comment.id
    const deletedComment = await deleteResource(`comment/${commentId}`, comment)
    return deletedComment
  }
}

export default CommentService
export const commentService = new CommentService()
